import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
  Grid2 as Grid,
} from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import parse from "html-react-parser";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";

import { useGetPublicLabgramQuery } from "api/public/labgrams/labgrams.api";
import Subheader from "components/Subheader";

const LabgramDetails = () => {
  const navigate = useNavigate();

  return (
    <>
      <Subheader pageName={"Labgrams"} />
      <Grid container display="flex" alignItems="start" my={2} mt={4}>
        <Grid size={2} display={"flex"} justifyContent="center">
          <Button
            color="warning"
            variant="contained"
            onClick={() => navigate("..")}
          >
            Back to labgrams
          </Button>
        </Grid>

        <Grid size={8} px={4}>
          <Typography flex={1} variant="h4">
            RESOURCES - LABGRAMS
          </Typography>

          <LabgramContent />
        </Grid>
        <Grid size={2} />
      </Grid>
    </>
  );
};

const LabgramContent = () => {
  const { id } = useParams();
  const {
    data: labgram,
    error,
    isLoading = true,
  } = useGetPublicLabgramQuery(id ?? skipToken);

  if (isLoading) {
    return (
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          my: 5,
        }}
      >
        <CircularProgress size={75} />
      </Container>
    );
  }

  if (!labgram || error) {
    return (
      <Typography align="center" my={5}>
        Could Not Find Labgram with this ID
      </Typography>
    );
  }

  const { subject, labgram: content, labgram_date, author } = labgram;

  const formattedDate = moment.utc(labgram_date).format("MM/DD/YYYY");

  return (
    <>
      <Typography variant="h5" fontWeight="bold" py={2}>
        {subject}
      </Typography>

      <Box>{parse(content)}</Box>

      <Typography variant="body2" align="right" mb={2}>
        {`Posted on ${formattedDate} by ${author}`}
      </Typography>
    </>
  );
};

export default LabgramDetails;
